<template>
  <v-card>
    <v-toolbar class="elevation-0">
      <v-list two-line>
        <v-list-tile style="background-color: transparent !important;">
          <v-list-tile-content class="truncate-content">
            <v-list-tile-title class="body-2">Registro de entrega</v-list-tile-title>
            <v-list-tile-sub-title class="caption">Total registrado: {{ cantidadEntregada }} de
              {{ item.cantidadFormulada }}
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-toolbar>
    <v-divider class="my-0"></v-divider>
    <v-container fluid grid-list-sm>
      <v-layout row wrap>
        <v-flex xs12>
          <v-switch
              v-model="result.esEntrega"
              label="Se realizó entrega"
              :false-value="0"
              :true-value="1"
          ></v-switch>
        </v-flex>
        <template v-if="result.esEntrega">
          <v-flex xs12>
            <v-menu
                key="menu"
                ref="fechaEntrega"
                v-model="fechaEntrega.menu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
            >
              <v-text-field
                  key="FecEntrega"
                  slot="activator"
                  label="Fecha entrega"
                  v-model="result.FecEntrega"
                  name="Fecha entrega"
                  prepend-icon="event"
                  v-validate="'required|date_format:yyyy-MM-dd|date_between:' + fechaEntrega.minDate + ',' + fechaEntrega.maxDate + ',true'"
                  :error-messages="errors.collect('Fecha entrega')"
                  readonly
              ></v-text-field>
              <v-date-picker
                  key="picker"
                  ref="picker"
                  v-model="result.FecEntrega"
                  locale="es-co"
                  :min="fechaEntrega.minDate"
                  :max="fechaEntrega.maxDate"
                  @input="$refs.fechaEntrega.save(result.FecEntrega)"
                  @change="() => {
							  let index = $validator.errors.items.findIndex(x => x.field === 'Fecha entrega')
							  $validator.errors.items.splice((index !== -1) ? index : 0, (index !== -1) ? 1 : 0)
							}"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12>
            <v-autocomplete
                v-if="tipoControl === 'CUM'"
                key="tipoControlCUM"
                label="Medicamento CUM"
                v-model="result.objetoSerTec"
                :items="cumsRemotos"
                :loading="loadingCUM"
                :search-input.sync="searchCUM"
                no-filter
                placehoder="Buscar por código, descripción comercial o principo activo"
                no-data-text="No hay resultados para mostrar"
                return-object
                name="medicamento CUM"
                v-validate="'required'"
                :error-messages="errors.collect('medicamento CUM')"
                @change="cum => {
                                    result.CodSerTecEntregado = `${cum.expediente}-${cum.consecutivocum}`
                                }"
            >
              <template slot="selection" slot-scope="data">
                <div style="width: 100% !important;">
                  <v-list-tile class="v-list-tile-pl0">
                    <v-list-tile-content class="truncate-content">
                      <v-list-tile-title class="body-2">{{ data.item.expediente }}-{{ data.item.consecutivocum }} |
                        {{ data.item.principioactivo }}
                      </v-list-tile-title>
                      <v-list-tile-sub-title style="font-size: xx-small !important;">{{ data.item.producto }}
                      </v-list-tile-sub-title>
                      <v-list-tile-sub-title style="font-size: xx-small !important;">{{
                          data.item.descripcioncomercial
                        }}
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider class="my-0"></v-divider>
                </div>
              </template>
              <template slot="item" slot-scope="data">
                <div style="width: 100% !important;">
                  <v-list-tile class="v-list-tile-pl0">
                    <v-list-tile-content>
                      <v-list-tile-title class="body-2">{{ data.item.expediente }}-{{ data.item.consecutivocum }} |
                        {{ data.item.principioactivo }}
                      </v-list-tile-title>
                      <v-list-tile-sub-title style="font-size: xx-small !important;">{{ data.item.producto }}
                      </v-list-tile-sub-title>
                      <v-list-tile-sub-title style="font-size: xx-small !important;">{{
                          data.item.descripcioncomercial
                        }}
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider class="my-0"></v-divider>
                </div>
              </template>
            </v-autocomplete>
            <v-text-field
                v-if="tipoControl === 'IUM'"
                key="tipoControlIUM"
                label="Medicamento IUM"
                v-model="result.CodSerTecEntregado"
                name="medicamento IUM"
                v-validate="'required'"
                :error-messages="errors.collect('medicamento IUM')"
            ></v-text-field>
            <v-autocomplete
                v-if="tipoControl === 'P'"
                key="tipoControlP"
                label="Procedimiento"
                v-model="result.objetoSerTec"
                :items="cupsRemotos"
                :loading="loadingCUP"
                :search-input.sync="searchCUP"
                no-filter
                placehoder="Buscar por código o descripción"
                no-data-text="No hay resultados para mostrar"
                return-object
                name="procedimiento"
                clearable
                v-validate="'required'"
                :error-messages="errors.collect('procedimiento')"
                @change="cup => {
                                    result.CodSerTecEntregado = `${cup ? cup.codigo : null}`
                                }"
            >
              <template slot="selection" slot-scope="data">
                <div style="width: 100% !important;">
                  <v-list-tile class="v-list-tile-pl0">
                    <v-list-tile-content class="truncate-content">
                      <v-list-tile-title class="body-2">{{ data.item.descripcion }}</v-list-tile-title>
                      <v-list-tile-sub-title class="caption">Código: {{ data.item.codigo }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </div>
              </template>
              <template slot="item" slot-scope="data">
                <div style="width: 100% !important;">
                  <v-list-tile class="v-list-tile-pl0">
                    <v-list-tile-content>
                      <v-list-tile-title class="body-2">{{ data.item.descripcion }}</v-list-tile-title>
                      <v-list-tile-sub-title class="caption">Código: {{ data.item.codigo }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </div>
              </template>
            </v-autocomplete>
            <v-autocomplete
                v-if="tipoControl === 'S'"
                key="tipoControlS"
                label="Servicio complementario"
                v-model="result.objetoSerTec"
                :items="getComplementarios"
                :filter="filterComunTecnologias"
                placehoder="Buscar por código o descripción"
                no-data-text="No hay resultados para mostrar"
                return-object
                name="servicio complementario"
                v-validate="'required'"
                :error-messages="errors.collect('servicio complementario')"
                @change="c => {
                                    result.CodSerTecEntregado = c.codigo
                                }"
            >
              <template slot="selection" slot-scope="data">
                <div style="width: 100% !important;">
                  <v-list-tile class="v-list-tile-pl0">
                    <v-list-tile-content class="truncate-content">
                      <v-list-tile-title class="body-2">{{ data.item.codigo }} - {{
                          data.item.descripcion
                        }}
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </div>
              </template>
              <template slot="item" slot-scope="data">
                <div style="width: 100% !important;">
                  <v-list-tile class="v-list-tile-pl0">
                    <v-list-tile-content>
                      <v-list-tile-title class="body-2">{{ data.item.codigo }} - {{
                          data.item.descripcion
                        }}
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </div>
              </template>
            </v-autocomplete>
            <v-autocomplete
                v-if="tipoControl === 'D'"
                key="tipoControlD"
                label="Dispositivo médico"
                v-model="result.objetoSerTec"
                :items="getDispositivos"
                :filter="filterComunTecnologias"
                placehoder="Buscar por código o descripción"
                no-data-text="No hay resultados para mostrar"
                return-object
                name="dispositivo médico"
                v-validate="'required'"
                :error-messages="errors.collect('dispositivo médico')"
                @change="c => {
                                    result.CodSerTecEntregado = c.codigo
                                }"
            >
              <template slot="selection" slot-scope="data">
                <div style="width: 100% !important;">
                  <v-list-tile class="v-list-tile-pl0">
                    <v-list-tile-content class="truncate-content">
                      <v-list-tile-title class="body-2">{{ data.item.codigo }} - {{
                          data.item.descripcion
                        }}
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </div>
              </template>
              <template slot="item" slot-scope="data">
                <div style="width: 100% !important;">
                  <v-list-tile class="v-list-tile-pl0">
                    <v-list-tile-content>
                      <v-list-tile-title class="body-2">{{ data.item.codigo }} - {{
                          data.item.descripcion
                        }}
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </div>
              </template>
            </v-autocomplete>
            <v-autocomplete
                v-if="tipoControl === 'N'"
                key="tipoControlN"
                label="Producto nutricional"
                v-model="result.objetoSerTec"
                :items="getNutricionales"
                :filter="filterComunTecnologias"
                placehoder="Buscar por código o descripción"
                no-data-text="No hay resultados para mostrar"
                return-object
                name="producto nutricional"
                v-validate="'required'"
                :error-messages="errors.collect('producto nutricional')"
                @change="c => {
                                    result.CodSerTecEntregado = c.codigo
                                }"
            >
              <template slot="selection" slot-scope="data">
                <div style="width: 100% !important;">
                  <v-list-tile class="v-list-tile-pl0">
                    <v-list-tile-content class="truncate-content">
                      <v-list-tile-title class="body-2">{{ data.item.codigo }} - {{
                          data.item.descripcion
                        }}
                      </v-list-tile-title>
                      <v-list-tile-title class="caption">{{ data.item.forma }} {{ data.item.presentacion }}
                        {{ data.item.unidades }}
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </div>
              </template>
              <template slot="item" slot-scope="data">
                <div style="width: 100% !important;">
                  <v-list-tile class="v-list-tile-pl0">
                    <v-list-tile-content>
                      <v-list-tile-title class="body-2">{{ data.item.codigo }} - {{
                          data.item.descripcion
                        }}
                      </v-list-tile-title>
                      <v-list-tile-title class="caption">{{ data.item.forma }} {{ data.item.presentacion }}
                        {{ data.item.unidades }}
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </div>
              </template>
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 sm12 :md6="reporteAutomatico" :md12="!reporteAutomatico">
            <v-text-field
                key="CantTotEntregada"
                label="Cantidad entregada"
                v-model.number="result.CantTotEntregada"
                name="Cantidad entregada"
                type="number"
                min="0"
                :max="maximaAEntregar"
                v-validate="'required|min_value:0|max_value:' + maximaAEntregar"
                :error-messages="errors.collect('Cantidad entregada')"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md6>
            <v-text-field
                v-if="reporteAutomatico"
                key="Valor"
                label="Valor entregado"
                v-model.number="result.ValorEntregado"
                name="Valor entregado"
                type="number"
                min="0"
                v-validate="'required|min_value:0|decimal:2'"
                :error-messages="errors.collect('Valor entregado')"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-switch
                key="EntTotal"
                v-model="result.EntTotal"
                label="Se realizó entrega total"
                :false-value="0"
                :true-value="1"
            ></v-switch>
          </v-flex>
        </template>
        <template v-else>
          <v-flex xs12>
            <v-autocomplete
                label="Causa de no entrega"
                v-model="result.CausaNoEntrega"
                :items="causasAplicables"
                item-value="id"
                item-text="causa"
                :filter="filterCausas"
            >
              <template slot="selection" slot-scope="data">
                <div style="width: 100% !important;">
                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title>{{ data.item.causa }}</v-list-tile-title>
                      <v-list-tile-sub-title class=caption>Aplica a: {{ data.item.aplica_a }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </div>
              </template>
              <template slot="item" slot-scope="data">
                <div style="width: 100% !important;">
                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title>{{ data.item.causa }}</v-list-tile-title>
                      <v-list-tile-sub-title class=caption>Aplica a: {{ data.item.aplica_a }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </div>
              </template>
            </v-autocomplete>
          </v-flex>
          <template
              v-if="result.CausaNoEntrega && causasAplicables.find(x => x.id === result.CausaNoEntrega).aplica_a !== 'No entrega total'">
            <v-flex xs12>
              <v-menu
                  key="menu"
                  ref="fechaEntrega"
                  v-model="fechaEntrega.menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
              >
                <v-text-field
                    key="FecEntrega"
                    slot="activator"
                    label="Fecha entrega"
                    v-model="result.FecEntrega"
                    name="Fecha entrega"
                    prepend-icon="event"
                    v-validate="'required|date_format:yyyy-MM-dd|date_between:' + fechaEntrega.minDate + ',' + fechaEntrega.maxDate + ',true'"
                    :error-messages="errors.collect('Fecha entrega')"
                    readonly
                ></v-text-field>
                <v-date-picker
                    key="picker"
                    ref="picker"
                    v-model="result.FecEntrega"
                    locale="es-co"
                    :min="fechaEntrega.minDate"
                    :max="fechaEntrega.maxDate"
                    @input="$refs.fechaEntrega.save(result.FecEntrega)"
                    @change="() => {
							  let index = $validator.errors.items.findIndex(x => x.field === 'Fecha entrega')
							  $validator.errors.items.splice((index !== -1) ? index : 0, (index !== -1) ? 1 : 0)
							}"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                  key="CantTotNoEntregada"
                  label="Cantidad no entregada"
                  v-model.number="result.CantTotEntregada"
                  name="cantidad no entregada"
                  type="number"
                  min="0"
                  :max="maximaAEntregar"
                  v-validate="'required|min_value:0|max_value:' + maximaAEntregar"
                  :error-messages="errors.collect('cantidad no entregada')"
              ></v-text-field>
            </v-flex>
          </template>
        </template>
      </v-layout>
    </v-container>
    <v-divider class="my-0"></v-divider>
    <v-card-actions>
      <v-btn
          @click="cancel"
          :disabled="load"
      >
        Cancelar
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
          color="primary"
          :loading="load"
          :disabled="load"
          @click="submit"
      >
        Entregar
      </v-btn>
    </v-card-actions>
    <app-section-loader :status="load"></app-section-loader>
  </v-card>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  props: {
    prescripcion: {
      type: Object,
      default: null
    },
    item: {
      type: Object,
      default: null
    },
    window: {
      type: Number,
      default: 0
    }
  },
  data: () => ({
    load: false,
    fechaEntrega: {
      menu: false,
      minDate: '1900-01-01',
      maxDate: new Date().toISOString().substr(0, 10)
    },
    causasNoEntrega: [],
    cumsRemotos: [],
    loadingCUM: false,
    searchCUM: null,
    cupsRemotos: [],
    loadingCUP: false,
    searchCUP: null,
    result: {
      esEntrega: 1,
      NoPrescripcion: null,
      TipoTec: null,
      ConTec: null,
      TipoIDPaciente: null,
      NoIDPaciente: null,
      NoEntrega: null,
      CodSerTecEntregado: null,
      CantTotEntregada: null,
      EntTotal: 0,
      CausaNoEntrega: 0,
      FecEntrega: null,
      NoLote: null,
      ValorEntregado: null,
      // objetos
      objetoSerTec: null
    },
    settings: null,
    tipoControl: null,
    codigoServicio: null,
    makeCodigoServicio: {
      visible: true,
      tipo: null,
      objeto: null
    },
    filterCausas: (item, queryText) => {
      const hasValue = val => val != null ? val : ''
      const text = hasValue(item.id + ' ' + item.causa + ' ' + item.aplica_a)
      const query = hasValue(queryText)
      return text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1
    },
    filterComunTecnologias: (item, queryText) => {
      const hasValue = val => val != null ? val : ''
      const text = hasValue(`${item.codigo} ${item.descripcion}`)
      const query = hasValue(queryText)
      return text.toString().toLowerCase().includes(query.toString().toLowerCase())
    }
  }),
  watch: {
    'result.esEntrega'(val) {
      !val && !this.causasNoEntrega.length && this.getCausasNoEntrega()
    },
    'window'(val) {
      if (val === 1) {
        this.getSettings()
        switch (this.item.TipoTec) {
          case 'M' :
            switch (this.item.objeto.TipoMed) {
              default:
                this.tipoControl = 'CUM'
                if (this.item.title) {
                  const rTemporal = this.item.title.split('[')
                  const rFinal = rTemporal[1] ? rTemporal[1].split(']') : null
                  rFinal[0] && this.buscarCUM(rFinal[0])
                }
                break
              case 2:
                this.tipoControl = 'VND'
                break
              case 3:
                this.tipoControl = 'MAGISTRAL'
                this.result.CodSerTecEntregado = ' '
                break
              case 7:
                this.tipoControl = 'UNIRS'
                break
              case 9:
                this.tipoControl = 'UM'
                break
            }
            break
          case 'P' :
            this.tipoControl = 'P'
            break
          case 'D' :
            this.tipoControl = 'D'
            break
          case 'N' :
            this.tipoControl = 'N'
            break
          case 'S' :
            this.tipoControl = 'S'
            break
        }
      }
    },
    'searchCUM'(val) {
      val && this.buscarCUM()
    },
    'searchCUP'(val) {
      val && this.buscarCUP()
    }
  },
  computed: {
    ...mapGetters([
      'getNutricionales',
      'getComplementarios',
      'getDispositivos'
    ]),
    maximaAEntregar() {
      return this.item ? Number(this.item.cantidadTotal) - this.cantidadEntregada : 0
    },
    cantidadEntregada() {
      return this.item.objeto.entregas && this.item.objeto.entregas.length ? window.lodash.sum(this.item.objeto.entregas.map(x => Number(x.CantTotEntregada))) : 0
    },
    reporteAutomatico() {
      return this.settings && this.settings[1] && this.settings[1].value === '1'
    },
    causasAplicables() {
      if (this.item) {
        const tipos = {
          M: 'medicamentos',
          P: 'procedimientos',
          D: 'dispositivos',
          N: 'nutricionales',
          S: 'complementarios'
        }
        return this.result && !this.result.esEntrega && this.causasNoEntrega.length ? this.causasNoEntrega.filter(x => (x[tipos[this.item.TipoTec]] === 1) && (this.cantidadEntregada > 0 ? x.aplica_a !== 'No entrega total' : x.aplica_a !== null)) : []
      }
      return []
    }
  },
  methods: {
    buscarCUM: window.lodash.debounce(async function () {
      if (this.searchCUM) {
        this.loadingCUM = true
        await this.$store.dispatch('getCUMs', this.searchCUM)
            .then(response => {
              this.cumsRemotos = response
              this.loadingCUM = false
            })
            .catch(e => {
              this.loadingCUM = false
              this.$store.commit('snackbar', {
                color: 'error',
                message: `al recuperar el servicio o tecnología ${this.item.type}`,
                error: e
              })
            })
      }
    }, 500),
    buscarCUP: window.lodash.debounce(async function () {
      if (this.searchCUP) {
        this.loadingCUP = true
        await this.$store.dispatch('searchCUPS', this.searchCUP)
            .then(response => {
              this.cupsRemotos = response
              this.loadingCUP = false
            })
            .catch(e => {
              this.loadingCUP = false
              this.$store.commit('snackbar', {
                color: 'error',
                message: `al recuperar el servicio o tecnología ${this.item.type}`,
                error: e
              })
            })
      }
    }, 500),
    submit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.loading()
          let data = null
          if (this.result.esEntrega) {
            data = {
              NoPrescripcion: this.prescripcion.NoPrescripcion,
              TipoIDPaciente: this.prescripcion.TipoIDPaciente,
              NoIDPaciente: this.prescripcion.NroIDPaciente,
              ConTec: this.item.objeto.ConOrden,
              TipoTec: this.item.TipoTec,
              NoEntrega: this.item.objeto.entregas.length + 1,
              CodSerTecEntregado: this.result.CodSerTecEntregado,
              CantTotEntregada: this.result.CantTotEntregada,
              EntTotal: this.result.EntTotal,
              FecEntrega: this.result.FecEntrega,
              NoLote: this.result.NoLote,
              CausaNoEntrega: 0
            }
            if (this.reporteAutomatico) data.ValorEntregado = this.valorDecimal(this.result.ValorEntregado)
          } else {
            data = {
              NoPrescripcion: this.prescripcion.NoPrescripcion,
              TipoIDPaciente: this.prescripcion.TipoIDPaciente,
              NoIDPaciente: this.prescripcion.NroIDPaciente,
              ConTec: this.item.objeto.ConOrden,
              TipoTec: this.item.TipoTec,
              NoEntrega: this.item.objeto.entregas.length + 1,
              CausaNoEntrega: this.result.CausaNoEntrega
            }
            if (this.causasAplicables.find(x => x.id === this.result.CausaNoEntrega).aplica_a !== 'No entrega total') {
              data.FecEntrega = this.result.FecEntrega
              data.CantTotEntregada = this.result.CantTotEntregada
            }
          }
          this.axios.post(`entregaAmbito`, data)
              .then((response) => {
                this.item.objeto.entregas.push(response.data)
                this.$store.commit('snackbar', {
                  color: 'success',
                  message: `La ${this.result.esEntrega ? 'ENTREGA' : 'NO ENTREGA'} se registró correctamente.`
                })
                this.$store.commit('reloadTable', 'tablePrescripciones')
                this.$store.commit('reloadTable', 'tableEntregas')
                this.cancel()
                this.loading(false)
              }).catch(e => {
            this.loading(false)
            this.$store.commit('snackbar', {
              color: 'error',
              message: `al registrar la ${this.result.esEntrega ? 'ENTREGA' : 'NO ENTREGA'}`,
              error: e
            })
          })
        }
      })
    },
    getCausasNoEntrega() {
      this.loading()
      this.axios.get(`causasnoentregas`)
          .then(response => {
            this.causasNoEntrega = response.data
            this.loading(false)
          }).catch(e => {
        this.loading(false)
        this.$store.commit('snackbar', {color: 'error', message: `al traer las causas de no entrega.`, error: e})
      })
    },
    getSettings() {
      this.axios.get(`settings`)
          .then(response => {
            this.settings = response.data
          }).catch(e => {
        this.$store.commit('snackbar', {color: 'error', message: `al traer la configuración global.`, error: e})
      })
    },
    loading(val = true) {
      this.load = val
    },
    cancel() {
      this.$emit('cancel')
      setTimeout(() => {
        this.load = false
        this.result.esEntrega = 1
        this.result.NoPrescripcion = null
        this.result.TipoTec = null
        this.result.ConTec = null
        this.result.TipoIDPaciente = null
        this.result.NoIDPaciente = null
        this.result.NoEntrega = null
        this.result.CodSerTecEntregado = null
        this.result.CantTotEntregada = null
        this.result.EntTotal = 0
        this.result.CausaNoEntrega = 0
        this.result.FecEntrega = null
        this.result.NoLote = null
        this.result.ValorEntregado = null
        this.result.objetoSerTec = null
        this.$validator.reset()
        this.settings = null
      }, 300)
    }
  }
}
</script>

<style scoped>

</style>
